// extracted by mini-css-extract-plugin
export default {"heart":"WishlistNav_heart__F4ffW"};